import { useContext } from 'react';
import { Base } from 'zf-web-components';
import { RootContext } from '@stores';
import { Avatar } from './avatar';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function DefaultToolsMenu(): ReactElement {
  const root = useContext(RootContext);
  const { user } = root;

  return (
    <Base.Space className={styles.toolsItem}>
      <Avatar />
      <span className={styles.headerText}>
        {user?.name ?? ''}
      </span>
    </Base.Space>
  );
}
